/**
 * The GeoJSON shape the location heatmap feeds to Supercluster: points only,
 * which is all the locations endpoint ever returns.
 */
export type FeatureCollection = {
    type: 'FeatureCollection';
    features: Array<{
        type: 'Feature';
        geometry: {
            type: 'Point';
            coordinates: Array<number>;
        };
        properties: {
            [key: string]:
                | string
                | number
                | boolean
                | object
                | null
                | undefined;
        };
    }>;
};

/** Wraps the raw `[lng, lat]` pairs the API returns as GeoJSON points. */
export function toFeatureCollection(
    coordinates: number[][]
): FeatureCollection {
    return {
        type: 'FeatureCollection',
        features: coordinates.map((coordinate) => ({
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: coordinate
            },
            properties: {}
        }))
    };
}
